module.exports = __webpack_public_path__ + "img/logo2.0@2x.f063227d.png";